var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section-download-file',{attrs:{"title":_vm.translations.certificatesPolicy,"file":_vm.getImgUrl(_vm.translations.certificatesPolicyFile)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }